"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormatNumberByNucleus = void 0;
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const PreferencesContext_1 = require("../context/PreferencesContext");
const formatNumber_1 = require("../utility/formatNumber");
function useFormatNumberByNucleus(nucleus) {
    const preferences = (0, PreferencesContext_1.usePreferences)();
    const nucleusByKey = (0, get_1.default)(preferences.current, `formatting.nuclei`, {
        ppm: '0.0',
        hz: '0.0',
    });
    return (0, react_1.useMemo)(() => {
        function formatFun(n) {
            return (value, formatKey = 'ppm', prefix = '', suffix = '') => {
                return (0, formatNumber_1.formatNumber)(value, nucleusByKey?.[n.toLowerCase()]?.[formatKey], {
                    prefix,
                    suffix,
                });
            };
        }
        if (!nucleus) {
            return () => undefined;
        }
        if (typeof nucleus === 'string') {
            return formatFun(nucleus);
        }
        else if (Array.isArray(nucleus)) {
            return nucleus.map((n) => formatFun(n));
        }
        else {
            throw new Error('nuclus must be string or array of string');
        }
    }, [nucleus, nucleusByKey]);
}
exports.useFormatNumberByNucleus = useFormatNumberByNucleus;
